<div class="cm-section-title">Outputs publishing</div>
@if ($configuraButtonProps(); as configuraButtonProps) {
    @if ($canPublish()) {
        <cm-material-output-publishing-button [props]="configuraButtonProps"></cm-material-output-publishing-button>
    } @else {
        <cm-hint>
            <ng-container cm-text>Publishing is only available to members of the organization that owns this material.</ng-container>
        </cm-hint>
    }
} @else {
    <cm-placeholder [dark]="true"></cm-placeholder>
}
